import React from "react";
import PropTypes from "prop-types";
import Slider from "components/Slider";
import styles from "./styles.module.scss";

const MinMaxSlider = ({
  onChange,
  min,
  max,
  prefixSign,
  floor,
  ceiling,
  onSliderMove,
}) => {
  const onMinChange = ({ target: { value } }) => {
    const parsedValue = value === "" ? "" : parseInt(value, 10);

    if (!Number.isNaN(parsedValue)) {
      onChange({
        min: parsedValue,
        max,
      });
    }
  };

  const onMaxChange = ({ target: { value } }) => {
    const parsedValue = value === "" ? "" : parseInt(value, 10);

    if (!Number.isNaN(parsedValue)) {
      onChange({
        min,
        max: parsedValue,
      });
    }
  };

  return (
    <>
      <div className={styles.priceRangeInputs}>
        <p className={styles.prefixSign}>{prefixSign}</p>
        <input
          className={styles.minInput}
          type="text"
          name="min"
          value={min}
          step={1}
          min={floor}
          max={ceiling}
          onChange={onMinChange}
        />
        <p className={styles.spacer}> - </p>
        <p className={styles.prefixSign}>{prefixSign}</p>
        {/* Prevents flexbox from applying to the two zeroHeight wrappers */}
        <div className={styles.maxInputWrapper}>
          {
            // Applies zero height to the two inputs so they stack on top of
            // one another.
          }
          <div className={styles.zeroHeightWrapper}>
            {
              // A "ghost" input that displays a "+" whenever a user has
              // selected the maximum possible value. Adding the "+" in this
              // way means that a user doesn't have to interact with the
              // "+" character while typing.
            }
            <input
              className={styles.backgroundMaxInput}
              disabled
              readOnly
              tabIndex={0}
              type="text"
              name="max"
              max={ceiling}
              value={max < ceiling ? max : `${ceiling}+`}
            />
          </div>
          <div className={styles.zeroHeightWrapper}>
            <input
              className={styles.maxInput}
              type="text"
              name="maxWriter"
              value={max}
              step={1}
              max={ceiling}
              onChange={onMaxChange}
            />
          </div>
        </div>
      </div>
      <Slider
        minValue={floor}
        maxValue={ceiling}
        leftHandleValue={min || floor}
        rightHandleValue={max || ceiling}
        onUpdate={([newMin, newMax]) =>
          onSliderMove({ min: newMin, max: newMax })
        }
        onChange={([newMin, newMax]) => onChange({ min: newMin, max: newMax })}
        step={1}
        className={styles.slider}
      />
    </>
  );
};

MinMaxSlider.propTypes = {
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  // The lowest value min can be.
  floor: PropTypes.number.isRequired,
  // The highest value max can be.
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  ceiling: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onSliderMove: PropTypes.func.isRequired,
  prefixSign: PropTypes.string,
};

MinMaxSlider.defaultProps = {
  prefixSign: null,
};

export default MinMaxSlider;
